import { styledThemed } from "../../../../../utils/styledThemed";

export const Button = styledThemed.button<{ isConnected: boolean }>`
  border: 1.5px solid ${(props) => props.theme.primaryColor};
  padding: 7px 30px;
  border-radius: 20px;
  text-transform: uppercase;
  margin-top: 20px;
  font-weight: 500;
  width: 100%;
  background: ${(props) => (props.isConnected ? props.theme.primaryColor : "none")};
  color: ${(props) => (props.isConnected ? "#fff" : "auto")};
  &:hover {
    background: ${(props) => props.theme.primaryColor};
    color: #fff;
  }
  &:focus {
    outline: none;
  }
  line-height: 14px;
  font-size: 13px;
  @media screen and (min-width: ${(props) => props.theme.large}) {
    font-size: 14px;
  }
`;

export const Connected = styledThemed.div`
  display: flex;
  justify-content: center;
  align-items: center;
  > svg {
    margin-right: 10px;
  }
`;
